var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeSets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6323 11.932C22.1035 9.61843 20.8476 8.1642 18.6001 6.97438C19.195 9.94894 16.0883 11.271 14.0391 10.61C14.4358 9.94894 14.6341 9.15573 14.6341 8.29641C14.6341 5.71845 12.5849 3.66931 10.007 3.66931C7.75951 3.66931 5.90867 5.25574 5.44597 7.43709C4.78495 7.56929 4.12394 7.63539 3.46292 7.63539C3.26462 7.63539 3.06632 7.7676 2.93411 7.8998C2.80191 8.032 2.80191 8.36251 2.93411 8.56081C3.33072 9.61843 4.52055 10.0811 5.84257 10.2794C5.97478 10.61 6.17308 10.9405 6.43749 11.2049C5.04936 12.1303 4.12394 13.7828 4.12394 15.5676C4.12394 18.476 6.50359 20.8557 9.41205 20.8557H15.6256C17.873 20.8557 19.9222 19.8641 21.3103 18.0794C22.6323 16.3608 23.1611 14.1133 22.6323 11.932ZM9.34595 6.31337C9.74255 6.31337 10.007 6.57777 10.007 6.97438C10.007 7.37099 9.74255 7.63539 9.34595 7.63539C8.94934 7.63539 8.68493 7.37099 8.68493 6.97438C8.68493 6.57777 9.01544 6.31337 9.34595 6.31337Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeSets);
export default __webpack_public_path__ + "static/media/shape-sets.48e1590eefd2f2aeb092e1d4d115d36a.svg";
export { ForwardRef as ReactComponent };